import '../browser_details.js';
